import { getCurrentUser } from './auth.js';

// Check if user is logged in and update UI accordingly
(async () => {
  const { user } = await getCurrentUser();

  // Get all signup buttons
  const headerSignupBtn = document.getElementById('headerSignupBtn');
  const heroSignupBtn = document.getElementById('heroSignupBtn');

  if (user) {
    // User is logged in - change buttons to "Dashboard" links
    if (headerSignupBtn) {
      headerSignupBtn.textContent = 'Dashboard';
      headerSignupBtn.href = 'src/dashboard.html';
    }
    if (heroSignupBtn) {
      heroSignupBtn.querySelector('span').textContent = 'Go to Dashboard';
      heroSignupBtn.href = 'src/dashboard.html';
    }
  }
})();
